
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { isDesktop } from '@/helpers/isDesktop';
import type { Phase } from '@/models/phase';
import type { Worksheet } from '@/models/worksheet';

@Component({
    name: 'FormPhaseMultiselect',
})
export default class FormPhaseMultiselect extends Vue {
    @Model('input', {
        required: true,
    })
    private modelPhases: Phase[];

    @Prop({
        required: true,
        default: () => [],
    })
    private availablePhases: Phase[];

    private isDesktop = isDesktop();

    get available() {
        return this.addAppliedLessonCountToPhases(this.availablePhases);
    }

    get selected() {
        return this.addAppliedLessonCountToPhases(this.modelPhases);
    }

    private addAppliedLessonCountToPhases(phases: Phase[]) {
        return phases.map((phase) => {
            const appliedLessonsCount = phase.worksheets
                ? phase.worksheets.reduce<number>((acc: number, cur: Worksheet) => {
                      return acc + cur.applied_lessons.length;
                  }, 0)
                : 0;

            return {
                ...phase,
                appliedLessonsCount,
            };
        });
    }
}
